module.exports = __webpack_public_path__ + "media/src/images/buttons/au-fb3c4546c8febd1bca9eb9973ad3a479.svg";